const cTogglesInit = () => {

  const toggles = document.querySelectorAll('.js-toggle')

  toggles.forEach(toggle => {
    const togglesTrigger = toggle.querySelector('.js-toggle-trigger')
    togglesTrigger.addEventListener('click', function (e) {

      togglesTrigger.parentElement.classList.toggle('is-active')
        setTimeout(function () {
          togglesTrigger.parentElement.classList.toggle('is-open');
        }, 20);

      // toggles.forEach(toggle => {
      //   if ( toggle.classList.contains('is-active') ) {
      //     toggle.classList.remove('is-active');
      //     toggle.classList.remove('is-open');
      //   }
      // });

    })
  })
}

export default cTogglesInit
